var DataStore = require('../store');
var store = DataStore.default


const getData = async (url) => {

    return new Promise((resolve, reject) => {
        fetch(url, {
            method: "GET",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            }
        })
            .then(res => res.json())
            .then(res_data => {
                resolve(res_data)
            });
    })

}



const getJenis = (wilayah) => {
    fetch(store.state.url.office_m_jenisSurat + "", {
        method: "GET",
        headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
        }
    })
        .then(res => res.json())
        .then(res_data => {
            console.log(res_data)
            store.state.list_jenis = res_data
        });
}

const getBentuk = (wilayah) => {
    fetch(store.state.url.office_m_bentukSurat + "", {
        method: "GET",
        headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
        }
    })
        .then(res => res.json())
        .then(res_data => {
            // console.log(res_data)
            store.state.list_bentuk = res_data
        });
}

const getSifat = () => {
    fetch(store.state.url.office_m_sifatSurat + "", {
        method: "GET",
        headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
        }
    })
        .then(res => res.json())
        .then(res_data => {
            // console.log(res_data)
            store.state.list_sifat = res_data
        });
}


const getBorang = () => {
    fetch(store.state.url.office_borang_acu + "", {
        method: "GET",
        headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
        }
    })
        .then(res => res.json())
        .then(res_data => {
            // console.log(res_data)
            store.state.list_borang = res_data
        });
}

const postBorang = (id) => {
    return new Promise((resolve, reject)=>{
        fetch(store.state.url.office_borang_acu + "getOne", {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
              id: id
            })
        })
            .then(res => res.json())
            .then(res_data => {
                // console.log(res_data)
                resolve(res_data)
            });
    })
}


const postUnitKerjaAuto = (unit_kerja) => {

        fetch(store.state.url.office_m_unit_kerja + "getUnitKerjaAutocomplete", {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                unit_kerja: unit_kerja
            })
        })
            .then(res => res.json())
            .then(res_data => {
                // console.log(res_data)
                store.state.list_unit_kerja_auto = res_data
                // resolve(res_data)
            });
}

const postUnitKerjaSearch = (unit_kerja) => {

    fetch(store.state.url.office_m_unit_kerja + "getUnitKerjaSearch", {
        method: "POST",
        headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({
            unit_kerja: unit_kerja
        })
    })
        .then(res => res.json())
        .then(res_data => {
            // console.log(res_data)
            store.state.list_unit_kerja_search = res_data
            // resolve(res_data)
        });
}


const postBiodata = async (unit_kerja, nama, limit) => {
    
    return new Promise((resolve, reject)=>{
        fetch(store.state.url.office_m_bioData + "list", {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                unit_kerja: unit_kerja,
                nama: nama,
                page_limit : limit,
            })
        })
            .then(res => res.json())
            .then(res_data => {
                // console.log(res_data)
                // store.state.list_biodata_auto = res_data
                resolve(res_data)
                return res_data
        });

    })

}
const postBiodataAuto = (unit_kerja, nama) => {
    // console.log(unit_kerja)
    fetch(store.state.url.office_m_bioData + "getBiodataAutocomplete", {
        method: "POST",
        headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({
            unit_kerja: unit_kerja,
            nama: nama
        })
    })
        .then(res => res.json())
        .then(res_data => {
            // console.log(res_data)
            store.state.list_biodata_auto = res_data
            // resolve(res_data)
        });
}



const postOnePemeriksa = (surat_id) => {
    return new Promise((resolve, reject)=>{
        fetch(store.state.url.office_sk_konsepSurat + "postOnePemeriksa", {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                surat_id: surat_id
            })
        })
            .then(res => res.json())
            .then(res_data => {
                resolve(res_data)
        });
    })
}

const postOnepenandaTangan = (surat_id) => {
    return new Promise((resolve, reject)=>{
        fetch(store.state.url.office_sk_konsepSurat + "postOnepenandaTangan", {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                surat_id: surat_id
            })
        })
            .then(res => res.json())
            .then(res_data => {
                resolve(res_data)
        });
    })
}

const postOnePenerima = (surat_id) => {
    return new Promise((resolve, reject)=>{
        fetch(store.state.url.office_sk_konsepSurat + "postOnePenerima", {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                surat_id: surat_id
            })
        })
            .then(res => res.json())
            .then(res_data => {
                // console.log(res_data)
                resolve(res_data)
        });
    })
}

const convertSurat = async (surat_id, type, fileOld) => {
    return new Promise((resolve, reject)=>{
        fetch(store.state.url.office_ConvertPDF + "convertToDF", {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                surat_id: surat_id,
                type : type,
                fileOld : fileOld,
                url: store.state.url.office_ConvertPDF +'/convertToPage?surat_id='+surat_id,
            })
        })
            .then(res_data => {
                resolve(res_data)
        });
    })

}

const resetStatus = async (data) => {
    return new Promise((resolve, reject)=>{
        fetch(store.state.url.office_sk_konsepSurat + "resetStatus", {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(data)
        })
            .then(res_data => {
                resolve(res_data)
        });
    })

}


const resetStatusTtd = async (data) => {
    return new Promise((resolve, reject)=>{
        fetch(store.state.url.office_sk_konsepSurat + "resetStatusTtd", {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(data)
        })
            .then(res_data => {
                resolve(res_data)
        });
    })

}

const postSmPenerimaSurat = async (surat_id) => {
    
    return new Promise((resolve, reject)=>{
        fetch(store.state.url.office_sm_verifikasiDisposisi + "sm_penerima_surat", {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                surat_id: surat_id
            })
        })
            .then(res => res.json())
            .then(res_data => {
                resolve(res_data)
                return res_data
        });

    })

}
const post = async () => {
    return new Promise((resolve, reject) => {
        setTimeout(function () {
            console.log("AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA");
            resolve()
        }, 5000);
    })
}


module.exports = {
    get: getData,
    post: post,
    getJenis: getJenis,
    getBentuk : getBentuk,
    getSifat : getSifat,
    getBorang : getBorang,
    postBorang : postBorang,
    postUnitKerjaAuto : postUnitKerjaAuto,
    postBiodata : postBiodata,
    postBiodataAuto : postBiodataAuto,
    postUnitKerjaSearch : postUnitKerjaSearch,

    postOnePemeriksa : postOnePemeriksa,
    postOnepenandaTangan : postOnepenandaTangan,
    postOnePenerima : postOnePenerima,

    convertSurat : convertSurat,
    resetStatus : resetStatus,
    resetStatusTtd : resetStatusTtd,
    postSmPenerimaSurat : postSmPenerimaSurat,
}